module.exports = __webpack_public_path__ + "static/media/_south-sudan.17098444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_south-sudan.svg
// module id = 2353
// module chunks = 7